import { createApp } from 'vue'

import i18n from '@/i18n'
import AppRoot from '@/Root.vue'
import { router } from '@/router'
import pinia from '@/store'
import updater from '@/updater'

import { useAuthStore } from './store/auth'
import { useConfigStore } from './store/config'

import './style.css'

const app = createApp(AppRoot)

app.config.performance = import.meta.env.DEV

app.use(pinia)
app.use(i18n)
app.use(router)

app.mount('#app')

const UPDATE_CHECK_INTERVAL = 5 * 60 * 1000

function init() {
  const authStore = useAuthStore(pinia)
  if (authStore.isAuthenticated) {
    const configStore = useConfigStore(pinia)
    configStore.refreshConfig()
    updater.notifyAppReady()
    updater.checkForUpdates()
    setInterval(() => updater.checkForUpdates(), UPDATE_CHECK_INTERVAL)
  }
}

init()
